import { render, staticRenderFns } from "./vehicle-player-image-stage.vue?vue&type=template&id=3a22c837&"
import script from "./vehicle-player-image-stage.vue?vue&type=script&lang=js&"
export * from "./vehicle-player-image-stage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports